// extracted by mini-css-extract-plugin
module.exports = {"deleteItem":"CardSidePanelToolbar_deleteItem__2hZ49","pinnedLabel":"CardSidePanelToolbar_pinnedLabel__jzKQy","openSelectItem":"CardSidePanelToolbar_openSelectItem__1P-Nk"};